<template>
  <!-- Skip to main content link -->
  <a
    href="#main-content"
    class="skip-link"
    @click.prevent="skipToMain"
  >
    Preskočiť na hlavný obsah
  </a>
</template>

<script>
export default {
  name: 'SkipLink',
  methods: {
    skipToMain() {
      const main = document.querySelector('#main-content') ||
                    document.querySelector('main') ||
                    document.querySelector('[role="main"]');
      
      if (main) {
        main.setAttribute('tabindex', '-1');
        main.focus();
        
        // Scroll to element
        main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
        // Remove tabindex after focus
        setTimeout(() => {
          main.removeAttribute('tabindex');
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: white;
  padding: 8px 16px;
  text-decoration: none;
  z-index: 9999;
  border-radius: 0 0 4px 0;
  font-weight: bold;
  transition: top 0.2s ease-in-out;
}

.skip-link:focus {
  top: 0;
  outline: 2px solid #fff;
  outline-offset: 2px;
}

/* Screen reader only class */
:global(.sr-only) {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
</style>
